/**
 * navbar-left module.
 * @module navbar-left
 */

$('#toggle-left').on('click', (e) => {
  if (CONF.IS_PRIMEPOOL) {
    $.get(CONF.BASE_URL + 'ajax/leftSitebar/toggle');
  }

  const bodyEl = $('#main-wrapper');
  $(window).width() > 767 ? $(bodyEl).toggleClass('sidebar-mini-1') : $(bodyEl).toggleClass('sidebar-opened');
});

/*
 * Send logout request. Necessary because of csrf protection.
 */
$('a#toggle-logout').on('click', (e) => {
  $('#logoutForm').submit();
});
